<div class="file-gallery">
    <div *ngFor="let fileObject of fileObjects; let i = index" class="file-container">
        <div *ngIf="isImage(fileObject); else pdfPreview">
            <div class="image-preview" [style.background-image]="'url(' + fileObject.url + ')'"
                (click)="maximizeFile($event, fileObject)">
                <div *ngIf="fileObject.processingStatus === 'processing'" class="processing-overlay">
                    <mat-spinner diameter="30" class="processing-spinner"></mat-spinner>
                    <span class="processing-text">Processing...</span>
                </div>
            </div>
        </div>
        <ng-template #pdfPreview>
            <div class="pdf-preview" (click)="maximizeFile($event, fileObject)" *ngIf="!fileObject.uploaded">
                <div class="pdf-icon">
                    <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <div class="pdf-text" *ngIf="fileObject.uploaded">
                    <p>Preview not available in gallery</p>
                    <p>Click to open</p>
                </div>
                <div class="pdf-text" *ngIf="!fileObject.uploaded">
                    <p>Click to preview</p>
                </div>
                <div *ngIf="fileObject.processingStatus === 'processing'" class="processing-overlay">
                    <mat-spinner diameter="30" class="processing-spinner"></mat-spinner>
                    <span class="processing-text">Processing documents...</span>
                </div>
            </div>
        </ng-template>
        <button mat-icon-button color="warn" (click)="removeFile($event, i)" *ngIf="deleteEnabled">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>